function storageKeyFor(id: string): string {
  return `working_${id}`;
}

// Persistence only: get by name (no preprocessing)
export function loadWorkingDocument(name: string, fallbackData: any): any {
  const key = storageKeyFor(name);
  const existing = typeof window !== 'undefined' ? localStorage.getItem(key) : null;
  if (existing) {
    try {
      return JSON.parse(existing);
    } catch {
      // ignore parse error and fall through
    }
  }
  // Return fallback as-is (no validation/preprocess here)
  return JSON.parse(JSON.stringify(fallbackData));
}

export function saveWorkingDocument(name: string, doc: any): void {
  const key = storageKeyFor(name);
  if (typeof window !== 'undefined') {
    localStorage.setItem(key, JSON.stringify(doc));
  }
}

export function downloadWorkingDocument(id: string, doc: any): void {
  const blob = new Blob([JSON.stringify(doc, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${id}.json`;
  a.click();
  URL.revokeObjectURL(url);
}


